import React from "react";
import style from "./Dropdown.module.css";

const Dropdown = ({
    value,
    handelChangeInput,
    options,
    name,
    defaultLabel,
    isLabelDisabled,
}) => {
    return (
        // value={value}
        <select
            onChange={(e) => handelChangeInput(e)}
            name={name}
            className={style.dropdownStyle}
            value={value}
        >
            <option
                value=""
                disabled={isLabelDisabled && isLabelDisabled}
                selected
            >
                {defaultLabel}
            </option>
            {options?.map((option, index) => (
                <option key={index} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default Dropdown;
